let tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.loadVideos = () => {
    [...document.querySelectorAll('[data-youtube-sdk-overlay]')].forEach((playerOverlay) => {
        const playerEl = playerOverlay.parentElement.querySelector('[data-youtube-sdk-player][data-video-id]')
        const swiper = playerOverlay.closest('swiper-carousel')?.swiper;
        if (!playerEl) return;

        function onPlayerStateChange(e) {
            if (e.data == -1 || e.data == 0) {
                playerOverlay.classList.remove('hidden', 'opacity-0');
                return;
            } else if (e.data == 2) {
                playerOverlay.classList.add('opacity-0');
                playerOverlay.classList.remove('hidden');
                return;
            }

            playerOverlay.classList.add('hidden');
        }

        const lazyLoad = (entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const player = new YT.Player(playerEl, {
								height: '390',
								width: '640',
								videoId: `${playerEl.dataset.videoId}`,
								playerVars: {
									playsinline: 1,
								},
								events: {
									onStateChange: onPlayerStateChange,
								},
							});

							playerOverlay.addEventListener('click', () => {
								if (player.getPlayerState() != 1) {
									player?.playVideo();
									return;
								}
							});

							function clickOutside(e) {
								if (
									e.target.closest(
										`[data-video-id="${playerEl.dataset.videoId}"]`
									) ||
									e.target.closest(
										`[data-youtube-sdk-overlay="${playerEl.dataset.videoId}"]`
									)
								)
									return;

								playerOverlay.classList.remove('hidden');
								player.pauseVideo();
								window.removeEventListener('click', (e) => clickOutside(e));
							}

							window.addEventListener('click', (e) => clickOutside(e));

							if (!swiper) return;
							swiper.on('activeIndexChange', () => {
								player?.pauseVideo();
							});
						}
					});
				};

				const observer = new IntersectionObserver(lazyLoad, {
					root: null,
					rootMargin: '0px',
					threshold: 0.1,
				});

				observer.observe(playerEl);
    })
}

function onYouTubeIframeAPIReady() {
    loadVideos();
}
